import { z } from "zod";
// Le persone come le mostra l'interfaccia, in un modulo che non dipende da nessun altro dei contratti: chi ha scritto
// qualcosa (l'istantanea dell'attore) e una persona dell'azienda nominata da una riga (l'owner di un Lead, l'assegnatario di un
// Task). Stanno qui e non in `leads.ts` perché la scheda del Lead porta il suo richiamo aperto (`task-view.ts`, piano M5,
// Task 16) e l'agenda dei Task porta le righe dei Lead (`tasks.ts`): con questi schemi in `leads.ts` i due moduli si
// importerebbero a vicenda, e uno dei due troverebbe l'altro non ancora valutato.
/**
 * Chi ha scritto qualcosa, come lo mostra l'interfaccia: il nome di allora (l'istantanea dell'attore) e se la
 * scrittura viene da Close. `fromClose` segue la provenienza, mai il tipo di attore.
 */
export const actorViewSchema = z.object({
    kind: z.enum(["membership", "platform", "system", "external"]),
    displayName: z.string(),
    fromClose: z.boolean(),
});
/** Una persona dell'azienda nominata da una riga, con il suo nome di adesso e se è ancora attiva. */
export const personSchema = z.object({ membershipId: z.string(), displayName: z.string(), active: z.boolean() });
//# sourceMappingURL=people.js.map